import useEntity from "../../hooks/useAccountingUser";
import AccountingUserDetail from "../../components/accountingUser/AccountingUserDetail/AccountingUserDetail";
import AccountingUserScoped from "../../components/accountingUser/AccountingUserDetail/AccountingUserScoped";
import AccountingUserTabs from "../../components/accountingUser/AccountingUserDetail/AccountingUserTabs";
import { useGetAccountingUserQuery } from "../../apis/AccountingUser.api";
import { PrimaryAccountingUser } from "../../types/models/AccountingUser";
import React from "react";
import {Delete, Edit} from "@mui/icons-material";
import {Box, Paper, Stack, Button} from "@mui/material";
import {NavLink, useParams, useSearchParams} from "react-router";
import {useStateSession} from "../../../hooks/useAuth";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const AccountingUserDetailPage = () => {

    useTitle(t`Details Accounting User`);

    const session = useStateSession()
    const [searchParams] = useSearchParams();
    const scoped = searchParams.get("scoped");
    const { accountingUserId: id } = useParams();

    const { data, refetch } = useGetAccountingUserQuery(PrimaryAccountingUser.fromPath(id))
    const { deleteAccountingUser } = useEntity();

    const onDelete = React.useCallback((e: any) => {
        e.stopPropagation()
        deleteAccountingUser(data, '..')
    }, [data, deleteAccountingUser])

    if (id === 'scoped') {
        return (<AccountingUserScoped/>)
    }

    return (
        <Box data-testid="AccountingUser-details">
            { data && <Paper sx={ { padding: "2em" } }>
                <AccountingUserDetail data={data} refetch={refetch} scoped={scoped}/>
                <Stack direction="row" spacing={1} sx={{ justifyContent: "center", marginTop: "2em"}}>
                    
                    { (session.hasPermission(
            data.scopeGroupId,
            'applications/timber/entities/AccountingUsers/update/view'
        ) ||
false) &&
                        <Button size="small" variant="outlined" data-testid="AccountingUser-edit-button" startIcon={<Edit />}
                                component={NavLink}
                                to="edit"
                                relative="route"
                                viewTransition={true}
                        >
                            <Trans>Edit</Trans>
                        </Button>
                    }
                    { (session.hasPermission(
            data.scopeGroupId,
            'applications/timber/entities/AccountingUsers/delete/view'
        ) ||
false) &&
                        <Button size="small" color="error" variant="outlined" data-testid="AccountingUser-delete-button" startIcon={<Delete />}  onClick={(e) => onDelete(e)}>
                            <Trans>Delete</Trans>
                        </Button>
                    }
                </Stack>
            </Paper>}

            { data && <Stack direction="row" spacing={1} sx={ { marginTop: "2em" } }>
                <AccountingUserTabs data={data} />
            </Stack>}
        </Box>
    )
}

export default AccountingUserDetailPage;
